exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-invalid {\n  border-left: solid 6px red; }\n\n.material-icons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-reset-password/app-reset-password.component.scss
// module id = ../../../../../src/app/components/app-reset-password/app-reset-password.component.scss
// module chunks = main